module.exports = __webpack_public_path__ + "assets/img/wx_qrcode.810d440c.jpg";